import React, {Fragment} from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {
    deleteDomain,
    getExpiringDomainsInGroup,
    loadDomainGroup,
    loadDomains,
    loadGroupTasks,
    loginTocPanel,
    loginToSoftware, updateDomainMeta
} from "../../actions/domains";
import {DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH, DEFAULT_PER_PAGE} from "../../config";
import {
    Space,
    Select,
    Button,
    Drawer,
    Table,
    Tabs,
    Tooltip,
    Typography,
    message,
    Tag, Dropdown,
    Popover,
    ConfigProvider, Alert, Row, Col, Popconfirm, Card
} from "antd";
import {InlineLoading} from "../../libs/loading";
import DomainOverview from "../../components/domain/DomainOverview";
import DNSZone from "../../components/domain/DNSZone";
import SubdomainsOverview from "../../components/domain/SubdomainsOverview";
import EmailAddressOverview from "../../components/domain/EmailAddressOverview";
import ExportOutlined from "@ant-design/icons/lib/icons/ExportOutlined";
import UndoOutlined from "@ant-design/icons/lib/icons/UndoOutlined";
import {isMobile} from 'react-device-detect';
import ExportModal from "../../components/domain/ExportModal";
import DomainRedirects from "../../components/domain/DomainRedirects";
import {displayErrors, normalizeEnum} from "../../libs/utils";
import GroupTasksTable from "../../components/domain/GroupTasksTable";
import {
    BarsOutlined,
    ClockCircleOutlined, DeleteOutlined,
    ExclamationCircleOutlined, PlusOutlined,
    FolderOpenOutlined, LoginOutlined,
    MinusCircleOutlined,
    SettingOutlined, WarningOutlined, CloseCircleOutlined, BranchesOutlined, SyncOutlined, CopyOutlined
} from "@ant-design/icons";
import GroupSettingsModal from "../../components/domain/GroupSettingsModal";
import AddDomainsForm from "../../components/domain/AddDomainsForm";
import DomainBulkUpdateModal from "../../components/domain/DomainBulkActionsModal";
import {StatusIndicator} from "../../components/shared/Status";
import SoftwarePresets from "../../components/domain/SoftwarePresets";
import AccessItem from "../../components/permissions/AccessItem";
import {hasPermission} from "../../components/permissions/PermissionUtils";
import AccessGate from "../../components/permissions/AccessGate";
import {MdEditNote, MdLogin, MdOutlineBolt} from "react-icons/md";
import DomainNotes from "../../components/domain/DomainNotes";
import {disableDriver} from "../../actions/driver";
import DomainAnalytics from "../../components/domain/DomainAnalytics";
import DomainAnalyticsMiniGraph from "../../components/domain/DomainAnalyticsMiniGraph";
import DomainHealthBox from "../../components/domain/DomainHealthBox";
import qs from "qs";
import WebsiteLauncher from "../../components/shared/WebsiteLauncher";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import DomainContentRules from "../../components/domain/DomainContentRules";
import {FaLock, FaLockOpen} from "react-icons/fa";

class DomainGroup extends React.Component {
    state = {
        domains: [],
        domainsLoaded: false,
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, showSizeChanger: true, total: 0 },
        filters: null,
        showActions: false,
        activeDomain: '',
        activeDomainName: '',
        selectedDomains: [],
        showDomainAddModal: false,
        domainOverviewDrawerWidth: isMobile ? window.innerWidth : DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH,
        showExportModal: false,
        searchQuery: [],
        searching: false,
        activeTab: 'domains',
        tasksSocket: null,
        isSubdomain: false,
        hostingType: 'SHARED_HOSTING',
        showSettingsModal: false,
        showBulkActionsModal: false,
        showExpirationWarning: false,
        domainOverViewActiveTab: 'domain',
        activeDomainData: null,
        loggingIntoSoftware: false,
        loggingIntoCpanel: false,
    };

    componentDidMount() {
        this.loadDomainGroupData();

        let parsed = qs.parse(this.props.location.search.substring(1));

        if(typeof parsed['show-add-domains'] !== 'undefined') {
            this.setState({ activeTab: 'add_domains' });
        }

        this.setState({
            activeTab: this.props.match.params.tab || 'domains'
        });

        const { page, perPage } = this.getPaginationFromURL();

        this.loadDomains(page, perPage);
    }

    componentDidUpdate(prevProps) {
        const { group, tab } = this.props.match.params;

        const groupChanged =
            prevProps.match.params.group !== group;

        const tabChanged =
            prevProps.match.params.tab !== tab;

        const searchChanged =
            prevProps.location.search !== this.props.location.search;

        if (tabChanged || groupChanged) {
            const activeTab = tab || 'domains';

            if (this.state.activeTab !== activeTab) {
                this.setState({ activeTab });
            }
        }

        if (groupChanged) {
            this.loadDomainGroupData();
        } else if (searchChanged) {
            const { page, perPage } = this.getPaginationFromURL();

            this.loadDomains(
                page,
                perPage,
                this.state.filters
            );
        }
    }

    loadDomains(page = null, per_page = null, filters = null) {
        if (page === null || per_page === null) {
            const pagination = this.getPaginationFromURL();

            if (page === null) {
                page = pagination.page;
            }

            if (per_page === null) {
                per_page = pagination.perPage;
            }
        }

        if (filters === null && this.state.filters !== null) {
            filters = this.state.filters;
        } else {
            this.setState({ filters });
        }

        if (this.state.searchQuery.length > 0) {
            page = 1;

            this.setState({
                searching: true
            });
        }

        this.setState({
            domainsLoaded: false
        });

        this.props.loadDomains(
            this.props.match.params.group,
            page,
            per_page,
            this.state.searchQuery,
            filters,
            (response) => {
                this.setState({
                    domainsLoaded: true,
                    searching: false,
                    domains: response.data.data,
                    pagination: {
                        current: response.data.page,
                        pageSize: response.data.per_page,
                        total: response.data.total,
                        showSizeChanger: true
                    }
                });
            },
            (err) => {
                if (typeof err.response !== 'undefined') {
                    displayErrors(err.response.data);

                    this.setState({
                        domainsLoaded: true,
                        searching: false
                    });
                }
            }
        );
    }

    getPaginationFromURL() {
        const params = new URLSearchParams(this.props.location.search);

        const page = parseInt(params.get('page'), 10) || 1;
        const perPage = parseInt(params.get('per_page'), 10) || 10;

        return {
            page,
            perPage
        };
    }

    updatePaginationURL(page, perPage) {
        const params = new URLSearchParams(this.props.location.search);

        params.set('page', page);
        params.set('per_page', perPage);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: params.toString()
        });
    }

    loadDomainGroupData(page = null, per_page = null) {
        this.setState({ domainsLoaded: false });

        this.props.loadDomainGroup(this.props.match.params.group, (res) => {
            this.props.updatePage(res.data.name);
            this.loadDomains(page, per_page);

            this.setState({
                defaultHostingAccount: res.data.default_hosting_account,
                isInternal: res.data.is_internal,
            })

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ domainsLoaded: true })
            }
        });

        this.props.getExpiringDomainsInGroup(this.props.match.params.group, (res) => {
            this.setState({ showExpirationWarning: res.data.expiring_domains > 0 })
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ showExpirationWarning: false })
            }
        });
    }

    onTableChange = (pagination, filters) => {
        let page = pagination.current;

        if (pagination.pageSize !== this.state.pagination.pageSize) {
            page = 1;
        }

        this.setState({
            filters
        }, () => {
            this.updatePaginationURL(
                page,
                pagination.pageSize
            );

            window.scrollTo(0, 0);
        });
    };

    tabChange = (key) => {
        if(isMobile) {
            this.setState({ domainOverviewDrawerWidth: window.innerWidth, domainOverViewActiveTab: key });
        } else {
            if(key === 'dns_zone' || key === 'email_addresses' || key === 'redirects' || key === 'subdomains') {
                this.setState({domainOverviewDrawerWidth: '900px', domainOverViewActiveTab: key});
            } else if(key === 'analytics' || key === 'content-rules') {
                this.setState({domainOverviewDrawerWidth: '1200px', domainOverViewActiveTab: key});
            } else if(key === 'manage-website') {
                this.setState({domainOverviewDrawerWidth: '1400px', domainOverViewActiveTab: key});
            } else {
                this.setState({ domainOverviewDrawerWidth: DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH, domainOverViewActiveTab: key });
            }
        }
    };

    updateSearchQuery(value) {
        if(value.length === 0) {
            return this.setState({ searchQuery: [] }, () => this.loadDomains());
        }

        let query = [];

        for(let i = 0; i < value.length; i++) {
            let item = value[i].trim();

            if(item !== '') {
                query.push(item)
            }
        }

        this.setState({ searchQuery: query });

        if(query.length === 0) {
            this.loadDomains();
        }
    }

    clearSearchAndLoadDomains() {
        this.setState({ searchQuery: []}, () => {
            this.loadDomains();
        });
    }

    loginToCpanel(guid) {
        if(this.state.loggingIntoCpanel) {
            return;
        }

        message.info('Creating cPanel login URL...');
        this.setState({ loggingIntoCpanel: true });

        this.props.loginTocPanel(guid, (res) => {
            window.open(res.data.redirect_url);
            this.setState({ loggingIntoCpanel: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loggingIntoCpanel: false });
            }
        });
    }

    loginToSoftware(guid) {
        if(this.state.loggingIntoSoftware) {
            return;
        }

        message.info('Creating software login URL...');
        this.setState({ loggingIntoSoftware: true });

        this.props.loginToSoftware(guid, (res) => {
            window.open(res.data.redirect_url);
            this.setState({ loggingIntoSoftware: false });
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loggingIntoSoftware: false });
            }
        });
    }

    toggleDomainCaching(guid, value) {
        let data = {
            cache_enabled: value,
        };

        this.props.updateDomainMeta(guid, data, () => {
            message.success('Domain\'s caching successfully updated! Allow up to 5 minutes for changes to take effect!');
            this.loadDomains(this.state.pagination.current, this.state.pagination.pageSize, this.state.filters);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false })
            }
        });
    }

    onTabChange(tab) {
        /*if(tab === 'add_domains' && this.props.wizard.currentStep === 8) {
            this.props.disableDriver();
        }

        if(tab === 'domains') {
            this.loadDomains();
        }

        this.setState({ activeTab: tab });*/

        if(tab === 'domains') {
            this.props.history.push('/domains/' + this.props.match.params.group);
        } else {
            this.props.history.push('/domains/' + this.props.match.params.group + '/' + tab);
        }
    }

    switchToTab(tab) {
        this.setState({ activeTab: tab });
    }

    runSearch() {
        if(this.state.searchQuery.length > 0) {
            this.loadDomains();
        }
    }

    closeOverview(onClose = null) {
        this.setState({
            domainOverViewActiveTab: 'domain',
            showActions: false,
            activeDomain: '',
            activeDomainData: null,
            domainOverviewDrawerWidth: DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH
        }, () => {
            if(onClose !== null) {
                onClose();
            }
        });
    }

    deleteDomain(guid) {
        this.props.deleteDomain(guid, () => {
            this.loadDomains();
            message.success('Domain deletion successfully scheduled!');
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    handleDropdownMenuClick = (data, guid) => {
        if(data.key === 'login-to-software') {
            this.loginToSoftware(guid);
        } else if(data.key === 'login-to-cpanel') {
            this.loginToCpanel(guid);
        }
    }

    render() {
        const columns = [
            { title: 'Domain', dataIndex: 'domain', key: 'domain', render: (item, record) => {
                let expirationWarning = '';
                    if (record.whois !== null && record.whois.days_until_expiration !== null) {
                        const days = record.whois.days_until_expiration;

                        if (days < 0) {
                            expirationWarning = (
                                <Tooltip title={`Domain expired ${Math.abs(days)} day${Math.abs(days) !== 1 ? 's' : ''} ago`}>
                                    <ExclamationCircleOutlined
                                        style={{
                                            color: '#ff4d4f',
                                            fontSize: '12px',
                                            marginLeft: '5px',
                                            marginBottom: '-2px'
                                        }}
                                    />
                                </Tooltip>
                            );
                        } else if (days <= 7) {
                            expirationWarning = (
                                <Tooltip title={`Domain expires in ${days} day${days !== 1 ? 's' : ''}`}>
                                    <ExclamationCircleOutlined
                                        style={{
                                            color: '#faad14',
                                            fontSize: '12px',
                                            marginLeft: '5px',
                                            marginBottom: '-2px'
                                        }}
                                    />
                                </Tooltip>
                            );
                        } else if (days <= 30) {
                            expirationWarning = (
                                <Tooltip title={`Domain expires in ${days} days`}>
                                    <ExclamationCircleOutlined
                                        style={{
                                            color: '#d9a000',
                                            fontSize: '12px',
                                            marginLeft: '5px',
                                            marginBottom: '-2px'
                                        }}
                                    />
                                </Tooltip>
                            );
                        }
                    }

                let sslBadge;

                    if(record.ssl_certificate === null) {
                        sslBadge = <Tooltip title='SSL certificate not installed'>
                            <FaLockOpen style={{color:'lightgray', cursor: 'help', fontSize: '13px', marginRight: '5px', marginBottom: '-2px' }} />
                        </Tooltip>;
                    } else {
                        if(record.ssl_certificate.status === 'ACTIVE') {
                            sslBadge = <Tooltip title='SSL certificate installed'>
                                <FaLock style={{color:'#91d591', cursor: 'help', fontSize: '13px', marginRight: '5px', marginBottom: '-2px'}} />
                            </Tooltip>;
                        } else {
                            sslBadge = <Tooltip title='SSL certificate is updating'><InlineLoading style={{marginRight: '5px'}} /></Tooltip>;
                        }
                    }

                return <Row justify='space-between' align="middle">
                    <Col style={{lineHeight: 1.2}}>
                        <div>
                            {sslBadge}
                            <a target='_blank' rel='noopener noreferrer' href={(record.has_ssl_certificate ? 'https://' : 'http://') + record.domain} style={{fontWeight: '600'}}>
                                {record.domain}
                            </a>
                            {expirationWarning}

                            <Tooltip title='Copy domain'>
                                <CopyOutlined
                                    className='domain-copy-icon'
                                    style={{
                                        marginLeft: '5px',
                                        marginRight: '5px',
                                        color: '#a3a3a3',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                    }}
                                    onClick={() => {
                                        navigator.clipboard.writeText(record.domain);
                                        message.success('Domain copied');
                                    }}
                                />
                            </Tooltip>
                        </div>
                        <div>
                            <div className="domain-ip-info">
                                <span className={'fi fi-' + record.ip_address.country_code.toLowerCase()}></span>
                                <span className="ip-address" style={{cursor: 'pointer'}}>
                                    <Tooltip title='Copy IP address' onClick={() => {
                                        navigator.clipboard.writeText(record.ip_address.ip_address);
                                        message.success('IP address copied');
                                    }}>{record.ip_address.ip_address}</Tooltip>
                                </span>

                                <span className="ip-location">
                                    · {record.ip_address.city}, {record.ip_address.country}
                                </span>

                                <span>
                                    {record.additional_ip_addresses.length > 0 ? <Tooltip title={record.additional_ip_addresses.length + ' additional IP address' + (record.additional_ip_addresses.length > 1 ? 'es' : '')}><BranchesOutlined style={{color: '#a3a3a3', cursor: 'pointer'}} /></Tooltip>: ''}
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        {record.has_notes ? <Tooltip title='Click to view domain notes!'>
                            <MdEditNote className='domain-notes' size='17' onClick={() => this.setState({ showActions: true, domainOverViewActiveTab: 'notes', activeDomain: record.guid })} />
                        </Tooltip> : ''}
                    </Col>
                </Row>
            }},
            { title: 'Cache', dataIndex: 'cache_enabled', filterMultiple: false, filters: [{text: 'Enabled', value: 'true'}, {text: 'Disabled', value: 'false'}], width: '50px', align: 'center', render: (item, record) => {
                let icon;

                if(item) {
                    icon = <MdOutlineBolt size='1.3em' style={{color: 'green', cursor: 'pointer'}} />;

                } else {
                    icon = <MdOutlineBolt size='1.3em' style={{color: '#a3a3a3', cursor: 'pointer'}} />;
                }

                return <Popconfirm
                    onConfirm={() => this.toggleDomainCaching(record.guid, !record.cache_enabled)}
                    title={<span>Are you sure you wish to {item ? 'disable': 'enable'} caching?</span>}
                    okText={item ? 'Disable': 'Enable'}
                    cancelText="Cancel">
                    <Tooltip title={'Caching is ' + (item ? 'enabled': 'disabled')}>{icon}</Tooltip>
                </Popconfirm>

            }},
            { title: 'Health', dataIndex: 'health', width: '150px', align: 'center', render: (item, record) => {

                if(typeof record.google_safe_browsing !== 'undefined' && record.google_safe_browsing !== null && record.google_safe_browsing.status !== null) {
                    return <Tooltip title={'Google Safe Browsing marked your domain unsafe!'}>{record.google_safe_browsing.status.map((status, i) => <Tag key={i} icon={<WarningOutlined />} style={{cursor: 'help'}} color="error">{normalizeEnum(status)}</Tag>)}</Tooltip>;
                }

                if(record.is_subdomain) {
                    return <Tooltip title={"Subdomains are excluded from health checks!"}><Tag icon={<MinusCircleOutlined />} style={{cursor: 'help'}} color="default">Subdomain</Tag></Tooltip>;
                }

                if(item === null || item.date_health_checked === null) {
                    return <Tooltip title={'Your domain\'s health has not been checked, yet! It can take up to 15 minutes after adding the domain.'}><Tag icon={<ClockCircleOutlined />} style={{cursor: 'help'}} color="default">Pending check</Tag></Tooltip>;
                }

                if(item.is_nxdomain) {
                    return <Tooltip title={"Your domain's nameservers don't respond. Contact your DNS host/registrar."}><Tag icon={<CloseCircleOutlined />} style={{cursor: 'help'}} color="error">NXDOMAIN</Tag></Tooltip>;
                }

                if(item.is_expired) {
                    return <Tooltip title={"Your domain is expired!"}><Tag icon={<CloseCircleOutlined />} style={{cursor: 'help'}} color="error">Expired</Tag></Tooltip>;
                }

                if(record.ip_address.ip_address !== item.resolved_ip_address || record.ip_address.ip_address !== item.resolved_www_ip_address) {
                    let content = <div style={{width: '500px'}}>
                        <DomainHealthBox ip_address={record.ip_address} domain={record} health={item} />
                    </div>;

                    return <Popover content={content} title='Domain Health' trigger="click">
                        <Tooltip title='Click for more information!'>
                            <Tag icon={<ExclamationCircleOutlined />} color="warning" style={{cursor: 'help'}}>Attention</Tag>
                        </Tooltip>
                    </Popover>;
                }

                return <Tooltip title='Everything is fine!'><Tag color='success' style={{cursor: 'help'}}>Healthy</Tag></Tooltip>
            }},
            { title: 'Status', width: '190px', dataIndex: 'status', filters: [
                    { text: 'Adding', value: 'ADDING'},
                    { text: 'Active', value: 'ACTIVE'},
                    { text: 'Pending', value: 'PENDING'},
                    { text: 'Deleting', value: 'DELETING'},
                    { text: 'Scheduled', value: 'SCHEDULED'},
                    { text: 'Updating', value: 'UPDATING'},
                    { text: 'Updating Hosting', value: 'UPDATING_HOSTING'}
                    ], key: 'status', align: 'center', render: (item) => <StatusIndicator status={item} el='badge' /> },

            { title: <span style={{lineHeight: '0.5'}}>Domain Metrics<div style={{fontSize: '9px', color: '#8b8b8b'}}>Domain Rating by <a style={{color: '#5d5c5c'}} href='https://ahrefs.com/' target='_blank' rel='noreferrer noopener'>Ahrefs</a></div></span>, align: 'center', width: '150px', render: (item, record) => {
                if(record.metrics === null || record.metrics.tf === null || record.metrics.da === null) {
                    return <Space>
                        <Tag color='#F7F6F6'><span style={{color: '#8b8b8b'}}>DR:</span> <SyncOutlined style={{color: '#666565'}} spin /></Tag>
                        <Tag color='#F7F6F6'><span style={{color: '#8b8b8b'}}>TF:</span> <SyncOutlined style={{color: '#666565'}} spin /></Tag>
                        <Tag color='#F7F6F6'><span style={{color: '#8b8b8b'}}>DA:</span> <SyncOutlined style={{color: '#666565'}} spin /></Tag>
                    </Space>;
                } else {
                    return <Space>
                        <Tag color='#F7F6F6'><Tooltip title='Domain Rating by Ahrefs'><abbr style={{color: '#8b8b8b', cursor: 'pointer'}}>DR:</abbr></Tooltip> <b><span style={{color: '#666565'}}>{record.metrics.dr}</span></b></Tag>
                        <Tag color='#F7F6F6'><Tooltip title='Trust Flow by Majestic'><abbr style={{color: '#8b8b8b', cursor: 'pointer'}}>TF:</abbr></Tooltip> <b><span style={{color: '#666565'}}>{record.metrics.tf}</span></b></Tag>
                        <Tag color='#F7F6F6'><Tooltip title='Domain Authority by Moz'><abbr style={{color: '#8b8b8b', cursor: 'pointer'}}>DA:</abbr></Tooltip> <b><span style={{color: '#666565'}}>{record.metrics.da}</span></b></Tag>
                    </Space>;
                }
            }},

            { title: 'Domain Traffic', dataIndex: 'traffic', align: 'center', width: 150, render: (item, record) => {
                return <DomainAnalyticsMiniGraph
                    domain={record.guid}
                    openAnalytics={() => {
                    this.setState({
                        showActions: true,
                        domainOverviewDrawerWidth: '1200px',
                        domainOverViewActiveTab: 'analytics',
                        activeDomain: record.guid
                    });
                }} />
            }},
            {
                title: 'Software', align: 'center', width: '50px', render: (item, record) => {
                    if (record.software === null) {
                        return <Tooltip title='Software not installed'>
                            <MdLogin style={{color: 'lightgray'}}/>
                        </Tooltip>;
                    }

                    if (record.software.status === 'ACTIVE') {
                        if (hasPermission(this.props.company.permissions, ['can_login_to_software'])) {
                            return <Tooltip title={'Login to ' + record.software.software_name}>
                                <MdLogin style={{color: 'green'}} onClick={() => this.loginToSoftware(record.guid)} className='cursor-pointer' />
                            </Tooltip>;
                        }
                    } else if(record.software.status === 'PENDING' || record.software.status === 'INSTALLING' || record.software.status === 'UNINSTALLING' || record.software.status === 'CLONING' || record.software.status === 'UPDATING') {
                        return <Tooltip title='Software is being updated...'>
                            <InlineLoading />
                        </Tooltip>;

                    } else {
                        return <Tooltip title='Software is busy'>
                            <MdLogin style={{color:'lightgray'}} />
                        </Tooltip>;
                    }
            }},
            { title: '', dataIndex: 'actions', align: 'right', width: 100, render: (item, record) => {
                let disabled = true;

                if(['ACTIVE', 'SUSPENDED'].indexOf(record.status) > -1) {
                    disabled = false;
                }

                let dropdownMenuItems = [];

                    if (record.software && hasPermission(this.props.company.permissions, ['can_login_to_software'])) {
                        dropdownMenuItems.push({ label: 'Login to ' + record.software.software_name, key: 'login-to-software', icon: <LoginOutlined /> })
                    }

                    if (record.hosting_type === 'SHARED_HOSTING' && hasPermission(this.props.company.permissions, ['can_login_to_hosting_accounts'])) {
                        dropdownMenuItems.push({ label: 'Login to cPanel', key: 'login-to-cpanel', icon: <LoginOutlined /> })
                    }

                    const dropDownMenu = {
                        items: dropdownMenuItems,
                        onClick: (e) => this.handleDropdownMenuClick(e, record.guid)
                    };

                    return <Space>
                        <Dropdown.Button
                            menu={dropDownMenu}
                            size='small'
                            onClick={() => this.setState({
                                activeDomainData: record,
                                activeDomain: record.guid,
                                isSubdomain: record.is_subdomain,
                                hostingType: record.hosting_type,
                                activeDomainName: record.domain,
                                showActions: true})}>
                            Actions
                        </Dropdown.Button>
                        <AccessItem scopes={['can_delete_domains']}>
                            <Popconfirm
                                onConfirm={() => this.deleteDomain(record.guid)}
                                placement='topRight'
                                title="Are you sure you want to delete this domain?"
                                okText="Delete Domain"
                                disabled={disabled}
                                cancelText="Cancel">
                                <Tooltip placement='left' title='Delete domain'>
                                    <Button disabled={disabled} icon={<DeleteOutlined />} type='text' style={{color: 'lightgray'}} />
                                </Tooltip>
                            </Popconfirm>
                        </AccessItem>
                    </Space>;
                }
            }
            ];

        const { TabPane } = Tabs;
        const { Title } = Typography;

        const analyticsAvailable = true;

        return <Card size='small'>
            <Tabs activeKey={this.state.activeTab} onChange={(tab) => this.onTabChange(tab)} destroyInactiveTabPane={true}>
                <TabPane tab='Domains' key='domains'>
                    <Row justify='space-between' style={{marginBottom: '10px', overflowX: 'auto'}}>
                        <Col span={22}>
                            <Space>
                                <AccessItem scopes={['can_add_domains']}>
                                    <Button type='primary' icon={<PlusOutlined />} onClick={() => this.setState({ activeTab: 'add_domains' })}>Add Domains</Button>
                                </AccessItem>
                                <AccessItem scopes={['can_edit_domains']}>
                                    <Tooltip title={this.state.selectedDomains.length === 0 ? 'Select at least one domain' : 'Execute bulk actions on selected domains'}>
                                        <Button disabled={this.state.selectedDomains.length === 0} icon={<BarsOutlined />} onClick={() => this.setState({ showBulkActionsModal: true})}>Bulk Actions</Button>
                                    </Tooltip>
                                </AccessItem>
                                <Tooltip title='Export domains'>
                                    <Button disabled={this.state.domains.length === 0} icon={<ExportOutlined />} onClick={() => this.setState({ showExportModal: true})}>Export</Button>
                                </Tooltip>
                                {this.props.user.user.panel_mode === 'ADVANCED' ? <AccessItem scopes={['can_edit_domain_groups']}>
                                    <Tooltip title='Edit domain group settings'>
                                        <Button icon={<SettingOutlined />} onClick={() => this.setState({ showSettingsModal: true})}>Settings</Button>
                                    </Tooltip>
                                </AccessItem> : null}
                                <Select
                                    value={this.state.searchQuery}
                                    maxTagCount={50}
                                    placeholder='Search'
                                    open={false}
                                    maxTagTextLength={10}
                                    onClear={() => this.clearSearchAndLoadDomains()}
                                    onInputKeyDown={(e) => { if(e.key === 'Enter') { this.runSearch() }}}
                                    allowClear loading={this.state.searching}
                                    mode="tags" style={{ width: '250px' }}
                                    onChange={(value) => this.updateSearchQuery(value)} tokenSeparators={[',', ' ']} />
                            </Space>
                        </Col>
                        <Col>
                            <Tooltip title='Reload table'>
                                <Button type='text' icon={<UndoOutlined />} onClick={() => this.loadDomains()}/>
                            </Tooltip>
                        </Col>
                    </Row>

                    <ConfigProvider renderEmpty={() => <div style={{textAlign: 'center'}}>
                        <FolderOpenOutlined style={{fontSize: 40}}/>
                        <p>Nothing to see here...</p>
                        <AccessItem scopes={['can_add_domains']}>
                            <Button type='primary' icon={<PlusOutlined/>}
                                    onClick={() => this.setState({activeTab: 'add_domains'})}>Add Domains</Button>
                        </AccessItem>
                    </div>}>
                        {this.state.showExpirationWarning ? <Alert type='warning' showIcon
                                                                   message={'There are one or more domains that will expire in less than 10 days or are already expired!'}/> : ''}
                        <div style={{overflowX: 'auto'}}>
                            <Table
                                rowSelection={{
                                    type: 'checkbox',
                                    selectedRowKeys: this.state.selectedDomains,
                                    onChange: (domains) => this.setState({selectedDomains: domains}),
                                    getCheckboxProps: (record) => ({
                                        disabled: record.status !== 'ACTIVE'
                                    }),
                                }}
                                onChange={this.onTableChange}
                                dataSource={this.state.domains}
                                columns={columns}
                                footer={this.state.selectedDomains.length > 0 ? () =>
                                    <span>{this.state.selectedDomains.length} selected</span> : null}
                                rowKey={(item) => item.guid}
                                pagination={this.state.pagination}
                                loading={!this.state.domainsLoaded}/>
                        </div>
                    </ConfigProvider>

                    <Drawer
                        placement="right"
                        className='domain-overview-drawer'
                        destroyOnClose={true}
                        closable={isMobile}
                        width={this.state.domainOverviewDrawerWidth}
                        onClose={() => this.closeOverview()}
                        open={this.state.showActions}>

                        <Title level={4}>{this.state.activeDomainName}</Title>

                        <Tabs defaultActiveKey={this.state.domainOverViewActiveTab}
                              activeKey={this.state.domainOverViewActiveTab}
                              onChange={(key) => this.tabChange(key)} destroyInactiveTabPane={true}>
                            <TabPane tab='Domain' key='domain'>
                                <DomainOverview
                                    isSubdomain={this.state.isSubdomain}
                                    hostingType={this.state.hostingType}
                                    history={this.props.history}
                                    closeOverview={() => this.closeOverview()}
                                    downloadSoftwareBackup={(guid) => this.downloadSoftwareBackup(guid)}
                                    loginToSoftware={(guid) => this.loginToSoftware(guid)}
                                    loginTocPanel={(guid) => this.loginToCpanel(guid)}
                                    guid={this.state.activeDomain}
                                    reloadDomains={() => this.loadDomainGroupData()} />
                            </TabPane>
                            <TabPane tab='Analytics' key='analytics'>
                                {analyticsAvailable ? <DomainAnalytics guid={this.state.activeDomain} /> : <Alert type='warning' showIcon message='Analytics are temporarily unavailable for this domain.' />}
                            </TabPane>
                            {!this.state.isSubdomain ? <Fragment>
                                <TabPane tab='DNS Zone' key='dns_zone'>
                                    <DNSZone guid={this.state.activeDomain} />
                                </TabPane>
                                <TabPane tab='Subdomains' key='subdomains'>
                                    <SubdomainsOverview manageSubdomain={(guid, hosting_type, domain) => {
                                        this.setState({
                                            activeDomain: guid, isSubdomain: true, domainOverViewActiveTab: 'domain',
                                            domainOverviewDrawerWidth: DEFAULT_DOMAIN_OVERVIEW_DRAWER_WIDTH,
                                            hostingType: hosting_type, activeDomainName: domain, showActions: true});
                                    }} guid={this.state.activeDomain} domainGroup={this.props.match.params.group} domainName={this.state.activeDomainName} />
                                </TabPane>
                                <TabPane tab='Email Addresses' key='email_addresses'>
                                    <EmailAddressOverview
                                        guid={this.state.activeDomain}
                                        hostingType={this.state.hostingType}
                                        domainName={this.state.activeDomainName} />
                                </TabPane>
                            </Fragment>: ''}

                            {hasPermission(this.props.company.permissions, ['can_view_domain_content_rules']) ? <TabPane tab={<span>Content Rules <Tag color="gold">Beta</Tag></span>} key='content-rules'>
                                <DomainContentRules guid={this.state.activeDomain} />
                            </TabPane> : ''}

                            <TabPane tab='URL Redirects' key='redirects'>
                                <DomainRedirects guid={this.state.activeDomain}  domainName={this.state.activeDomainName} />
                            </TabPane>
                            <TabPane tab='Notes' key='notes'>
                                <DomainNotes guid={this.state.activeDomain} />
                            </TabPane>
                        </Tabs>
                    </Drawer>

                    <GroupSettingsModal
                        showModal={this.state.showSettingsModal}
                        group={this.props.match.params.group}
                        isInternal={this.state.isInternal}
                        reloadGroup={() => {
                            this.loadDomains();
                            this.loadDomainGroupData();
                        }}
                        close={() => this.setState({ showSettingsModal: false })}/>

                    <ExportModal showModal={this.state.showExportModal}
                                 group={this.props.match.params.group}
                                 selecteDomains={this.state.selectedDomains}
                                 closeModal={() => this.setState({ showExportModal: false })} />

                    <DomainBulkUpdateModal
                        selectedDomains={this.state.selectedDomains}
                        showModal={this.state.showBulkActionsModal}
                        domainGroup={this.props.match.params.group}
                        reloadDomains={() => this.loadDomains()}
                        deselectDomains={() => this.setState({ selectedDomains: [] })}
                        close={() => this.setState({ showBulkActionsModal: false })} />

                </TabPane>
                <TabPane tab='Add Domains' key='add'>
                    <AccessGate scopes={['can_add_domains']}>
                        {this.props.user.user.panel_mode === 'SIMPLE' ? <WebsiteLauncher history={this.props.history} /> : <AddDomainsForm
                            defaultHostingAccount={this.state.defaultHostingAccount}
                            group={this.props.match.params.group}
                            closeAddSwitchToDomainTab={() => {
                                this.loadDomainGroupData();
                                this.props.history.push('/domains/' + this.props.match.params.group)
                            }}/>}

                    </AccessGate>
                </TabPane>

                { this.props.user.user.panel_mode === 'ADVANCED' ? <TabPane tab='Tasks' key='tasks'>
                    <GroupTasksTable
                        group={this.props.match.params.group}
                        socket={this.state.tasksSocket} />
                </TabPane> : null}

                { this.props.user.user.panel_mode === 'ADVANCED' ? <TabPane tab='Software Presets' key='software-presets'>
                    <AccessGate scopes={['can_view_software_presets']}>
                        <SoftwarePresets />
                    </AccessGate>
                </TabPane> : null}
            </Tabs>
        </Card>;
    }
}

const mapStateToProps = state => ({
    user: state.auth.user,
    company: state.auth.user.user.company,
    wizard: state.getting_started_wizard
});

export default connect(mapStateToProps, { updatePage, loadDomainGroup, loadDomains, loadGroupTasks,
    loginTocPanel, loginToSoftware, getExpiringDomainsInGroup, deleteDomain, disableDriver, updateDomainMeta })(DomainGroup);